<canvas #barCanvas style="width: 100%; height: 500px;"></canvas>
